import { createContext, useCallback, useContext, useEffect, useState } from 'react';
import seed from '../data/catalogSeed.json';
import { request } from './Auth';
const Context = createContext(null);
const previewFallback = !process.env.REACT_APP_FIREBASE_PROJECT_ID;
export function CatalogProvider({ children }) {
  const [items, setItems] = useState(previewFallback ? seed.items : []);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);
  const reload = useCallback(async () => {
    setLoading(true);
    try { const data = await request('/api/content'); if (!Array.isArray(data.items)) throw new Error('Invalid content response.'); setItems(data.items); setError(''); }
    catch { if (!previewFallback) setItems([]); setError(previewFallback ? 'Live updates are unavailable. Showing the existing collection.' : 'The content library is temporarily unavailable. Please try again shortly.'); }
    finally { setLoading(false); }
  }, []);
  useEffect(() => { reload(); }, [reload]);
  return <Context.Provider value={{ items, error, loading, reload }}>{children}</Context.Provider>;
}
export const useCatalog = () => useContext(Context);
export function CatalogNotice() { const { error } = useCatalog(); return error ? <p className="service-notice" role="status">{error}</p> : null; }
export function contentPath(item) {
  const base = { comics: 'comics', animations: 'animations', galleries: 'portfolio', artwork: 'art', stories: 'stories', blog: 'blog', essays: 'blog/essays' };
  return `/${base[item.type]}/${item.id}`;
}
